export const getResponseMessage = (response, fallback = "") =>
  response?.message || fallback;

const formatValidationDetails = (details) => {
  if (typeof details === "string") return details;
  if (!Array.isArray(details)) return "";

  return details
    .map((detail) => {
      const field = Array.isArray(detail?.loc)
        ? detail.loc.filter((part) => part !== "body").join(".")
        : "";
      const message = detail?.msg || "Invalid value";

      return field ? `${field}: ${message}` : message;
    })
    .filter(Boolean)
    .join(" ");
};

export const getRequestErrorMessage = (error, fallback = "Request failed.") => {
  const validationMessage = formatValidationDetails(error?.data?.detail);

  return (
    error?.data?.message ||
    validationMessage ||
    error?.error ||
    error?.message ||
    fallback
  );
};

export const assertSuccessfulResponse = (response, fallback = "Request failed.") => {
  if (response?.status === "failed") {
    throw new Error(getResponseMessage(response, fallback));
  }

  return response;
};
